<div role="button" class="tile"
     [tabIndex]="tabindex"
     [ngClass]="{'disabled': disabled, 'content-from-top': contentFromTop, 'more-than-3-tiles': customDesignTiles}"
     [attr.aria-label]="ariaLabel"
     (click)="tileClickEvent.emit()"
     (keyup)="onKeyUp($event)">
    <app-status-label *ngIf="inDevelopment"
                      [cssClasses]="'status-label__gray status-label__disabled-status status-label__top-right'"
                      [icon]="'code'"
                      [statusLabelText]="'GENERAL.IN_DEVELOPMENT' | translate">
    </app-status-label>
    <div class="tile__inner">
        <ng-content select="[language-option]"></ng-content>
        <mat-icon *ngIf="icon" class="tile__inner__icon material-icons-round" [ngClass]="{'smaller-icon': customDesignTiles}">{{icon}}</mat-icon>
        <mat-icon *ngIf="customIcon" class="tile__inner__icon material-icons-round custom-icon" [ngClass]="{'smaller-icon': customDesignTiles}"
                  svgIcon='{{customIcon}}'></mat-icon>
        <h3 class="tile__inner__title">{{title}}</h3>
        <p *ngIf="text" class="tile__inner__text">{{text}}</p>
        <div class="tile__inner__content">
            <ng-content select="[list]"></ng-content>
        </div>
    </div>
</div>
